import { render, staticRenderFns } from "./OpdrachtItemUitgezet.vue?vue&type=template&id=b268c02c&scoped=true&"
import script from "./OpdrachtItemUitgezet.vue?vue&type=script&lang=js&"
export * from "./OpdrachtItemUitgezet.vue?vue&type=script&lang=js&"
import style0 from "./OpdrachtItemUitgezet.vue?vue&type=style&index=0&id=b268c02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b268c02c",
  null
  
)

export default component.exports